import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useCustomerCommentsStore } from '@pages/customers'
import { normalizeArrayQuery } from '@shared/lib/routes'
import { foldBracketArrayParams } from '@shared/lib/url'

import { defineNuxtRouteMiddleware, navigateTo } from '#app'

const ARRAY_KEYS = ['disciplines'] as const

/** `/customers/{id}/comments` — the `disciplines` query → store filter; legacy `disciplines[0]=…` links are folded once. */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const folded = foldBracketArrayParams(to.query, ARRAY_KEYS)

  if (folded) {
    return navigateTo({ path: to.path, query: folded }, { replace: true })
  }

  useCustomerCommentsStore().setFilterDisciplines(normalizeArrayQuery(to.query?.disciplines) ?? [])
})
